type BannerSelection = {
  id: number;
  featuredRank?: number; // optional to preserve compatibility if present
};

const FEATURED_BANNER_KEY = "featuredBanner";

export function getFeaturedBannerSelection(): BannerSelection | null {
  const raw = localStorage.getItem(FEATURED_BANNER_KEY);
  if (!raw) return null;

  try {
    const parsed = JSON.parse(raw) as unknown;

    if (
      typeof parsed === "object" &&
      parsed !== null &&
      "id" in parsed &&
      typeof (parsed as any).id === "number"
    ) {
      const maybeRank = (parsed as any).featuredRank;

      return {
        id: (parsed as any).id,
        featuredRank: typeof maybeRank === "number" ? maybeRank : undefined,
      };
    }

    return null;
  } catch {
    return null;
  }
}

export function setFeaturedBannerSelection(selection: BannerSelection): void {
  localStorage.setItem(FEATURED_BANNER_KEY, JSON.stringify(selection));
}
